/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";

const Canvas = () => {
  const {
    canvasRef,
    canvasOptions,
    imageRef,
    canvasImg,
    canvasBg,
  } = useContext(PanelsContext);

  return (
    <div style={{ background: canvasBg }} css={styles}>
      <canvas ref={canvasRef}></canvas>
      <img
        onLoad={canvasOptions}
        className="hidden"
        ref={imageRef}
        src={canvasImg}
        alt="canvas"
      />
    </div>
  );
};

const styles = css`
  width: 100%;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px 0;
  .hidden {
    display: none;
  }
  @media (max-width: 450px) {
    canvas {
      width: 90%;
    }
  }
`;

export default Canvas;
